import ProResponse from 'types/ProResponse';
import RecurlyPlan from 'types/RecurlyPlan';
import { ServerCommunicationUtil } from 'utils/server_communication_util';

type ProSubscription = {
  apple_pay_token?: string;
  paypal_token?: string;
  recurly_plan_code: RecurlyPlan;
  uid: number;
};

// see def subscribe_pro
export default async function pro(body: ProSubscription): Promise<ProResponse> {
  const response = await fetch('/pro', {
    body: JSON.stringify(body),
    headers: {
      ...ServerCommunicationUtil.defaultAuthHeaders(),
      'Content-Type': 'application/json',
      'X-Language-Locale': __AT_DATA__.languageRegionCode
    },
    method: 'PUT'
  });

  if (response.ok) {
    return undefined; // make eslint happy
  }

  const errors = await response.json();

  return { errors };
}
